import { Navigate, useLocation } from "react-router-dom";

const RemoveTrailingSlash = () => {
  const { pathname, search } = useLocation();
  const hasTrailingSlash = pathname !== "/" && pathname.endsWith("/");

  if (!hasTrailingSlash) {
    return null;
  }

  return (
    <Navigate
      replace
      to={{
        pathname: pathname.replace(/\/+$/, ""),
        search,
      }}
    />
  );
};

export default RemoveTrailingSlash;
